import axios from "axios";

const axiosApp = axios.create({
   baseURL: `https://navy-bird-comics2-0-6r7f.vercel.app/`,
});

export default axiosApp;
